import React from 'react';
import { NavLink } from "react-router-dom";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import FadeInSection from "../../FadeInup/FadeInup";

const ProductShowcase = ({ h3RefHome, isH3Visible }) => {
    return (
        <div className="container mb-5">
            <div className="row justify-content-center">
                <div className="col-lg-8 mt-3">
                    <div className="Faqtitle product-margintop">
                        <h3 className={`border-bottom-animation h3hoverbefore ${isH3Visible ? 'active' : ''}`} ref={h3RefHome}>Best of Colorbot</h3>
                        <br />
                    </div>
                </div>
            </div>
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <div className="Homebox">
                        <LazyLoadImage 
                            src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/home-product-stella1.webp"}
                            width={"100%"}
                            className="img-fluid" 
                            alt="Image of Colorbot Stella"
                            effect="blur"
                        />
                        <NavLink to="/colorbot-stella"> 
                            <button className="btn homequick">Quick View</button>
                        </NavLink>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="Homebox">
                        <LazyLoadImage 
                            src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/home-product-stellaquad2.webp"}
                            width={"100%"}
                            className="img-fluid" 
                            alt="Image of Colorbot Stella Quad"
                            effect="blur"
                        />
                        <NavLink to="/colorbot-stella-quad"> 
                            <button className="btn homequick">Quick View</button>
                        </NavLink>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="Homebox">
                        <LazyLoadImage 
                            src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/home-product-knoxx3.webp"}
                            width={"100%"}
                            className="img-fluid" 
                            alt="Image of Colorbot Knoxx"
                            effect="blur"
                        />
                        <NavLink to="/colorbot-knoxx"> 
                            <button className="btn homequick">Quick View</button>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ProductShowcase);
